import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef, MatPaginator, MatTableDataSource} from "@angular/material";
import {HeaderTempateVO} from "../InjectionVO";
import {BaseComponent} from "../BaseComponent";

@Component({
  selector: 'app-upload-file',
  templateUrl: './upload-file.component.html',
  styleUrls: ['./upload-file.component.css']
})
export class UploadFileComponent extends BaseComponent implements OnInit {


  displayedColumns = ['sheet', 'userName', 'date', 'motif',
    'vstart1', 'vend1',
    'vstart2', 'vend2',
    'vstart3', 'vend3',
    'vstart4', 'vend4', 'pause'];

  headerFileMapping = {
    'Matricule': 'useName',
    'Journée(DD/MM/YYYY)': 'date',
    'Début vac 1(HH:mm)': 'vstart1',
    'Fin vac 1(HH:mm)': 'vend1',
    'Début vac 2(HH:mm)': 'vstart2',
    'Fin vac 2(HH:mm)': 'vend2',
    'Début vac 3(HH:mm)': 'vstart3',
    'Fin vac 3(HH:mm)': 'vend3',
    'Début vac 4(HH:mm)': 'vstart4',
    'Fin vac 4(HH:mm)': 'vend4',
    'Pause (mm)': 'pause',
    'Timezone': 'timezone',
    'sheet': 'sheet'
  }

  dataSource = new MatTableDataSource<any>([]);

  @ViewChild(MatPaginator) paginator: MatPaginator;


  constructor(public dialogRef: MatDialogRef<UploadFileComponent>, @Inject(MAT_DIALOG_DATA) public data: {
    rows: Array<Array<HeaderTempateVO>>,
    source: any
  }) {
    super();
  }
  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }

  ngOnInit() {
    this.dataSource.data = this.mappingValues();
  }


  mappingValues() {
    const rows = (this.data.rows as any).flat().map((row: HeaderTempateVO) => {
      const o = {};

      Object.keys(this.headerFileMapping).forEach((key) => {
        o[this.headerFileMapping[key]] = row[key] || null;
      });

      return o;
    });

    return rows;
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/injection/upload-file/upload-file.component.ts